import {EventEmitter} from 'events';
import assign from 'object-assign';

const Dispatcher = assign({}, EventEmitter.prototype, {

  BRAND_CHANGE                      : 'Brand.change',

  DEVICE_STORE_CHANGE               : 'Device.storeChange',
  DEVICE_DEACTIVATE_DEVICE          : 'Device.deactiveDevice',

  HEADER_HAMBURGER_CHANGE           : 'Header.hamburgerChange',
  HEADER_HAMBURGER_TOGGLE           : 'Header.hamburgerToggle',
  HEADER_HAMBURGER_OFF              : 'Header.hamburgerOff',

  RESOURCE_STORE_CHANGE             : 'Resource.storeChange',

  RESOURCE_DETAILS_STORE_CHANGE     : 'ResourceDetails.storeChange',

  TRANSACTION_STORE_CHANGE          : 'Transaction.storeChange',
  TRANSACTION_REQUEST_REFUND        : 'Transaction.requestRefund',
  TRANSACTION_REFUND_SUCCESS        : 'Transaction.refundSuccess',
  TRANSACTION_REFUND_FAILURE        : 'Transaction.refundFailure',

  USER_STORE_CHANGE                 : 'User.storeChange',
  USER_CHANGE_PASSWORD              : 'User.changePassword',
  USER_CHANGE_PASSWORD_SUCCESS      : 'User.changePasswordSuccess',
  USER_CHANGE_PASSWORD_FAILURE      : 'User.changePasswordFailure',
  USER_LICENSE_UPDATED              : 'User.licenseUpdated',
  USER_SET_INFO                     : 'User.setInfosdfsdf',
  USER_SIGN_OUT                     : 'User.signOut',
  USER_UPDATE_NOTIFICATION          : 'User.updateNotification',
  USER_UPDATE_NOTIFICATION_SUCCESS  : 'User.updateNotificationSuccess',
  USER_UPDATE_NOTIFICATION_FAILURE  : 'User.updateNotificationFailure',
  USER_UPDATE_SECURITY_QUESTION     : 'User.updateScurityQuestion',
  USER_UPDATE_SECURITY_SUCCESS      : 'User.updateScuritySuccess',
  USER_UPDATE_SECURITY_FAILURE      : 'User.updateScurityFailure',
  USER_UPDATE_SUCCESS               : 'User.updateSuccess',
  USER_UPDATE_FAILURE               : 'User.updateFailure',
  USER_POD                          : 'User.pod',

  LOCALE_CHANGE                     : 'Locale.Change'
});

export default Dispatcher;
